import {Api, Method} from "../../api/api";
import {showToast} from "../../toast";

const selectors = {
  imageElement: `.js-avatar-image`,
  removeButtonElement: `.js-avatar-remove`,
};

const DEFAULT_AVATAR_URL = `/img/profile/user.svg`;

class Avatar {
  private readonly formElement: HTMLFormElement;
  private imageElement: HTMLImageElement;
  private readonly actionUrl: string;
  private removeButtonElement: HTMLElement;

  private api = new Api();

  constructor(selector) {
    this.formElement = document.querySelector(selector);
    this.imageElement = this.formElement.querySelector(selectors.imageElement)!;
    this.removeButtonElement = this.formElement.querySelector(selectors.removeButtonElement)!;
    this.actionUrl = this.formElement.action;

    this.onFormChange = this.onFormChange.bind(this);
    this.onRemoveButtonClick = this.onRemoveButtonClick.bind(this);
  }

  init() {
    this.formElement.addEventListener(`change`, this.onFormChange);
    this.removeButtonElement.addEventListener(`click`, this.onRemoveButtonClick);
  }

  private getFormData() {
    return new FormData(this.formElement);
  }

  private setImageElement(src) {
    this.imageElement.src = src;
  }

  private async post(isRemove?) {
    const options = {
      method: !isRemove ? Method.POST : Method.GET,
      query: !isRemove ? this.getFormData() : undefined,
    };
    const url = !isRemove ? this.actionUrl : `${this.actionUrl}?isRemove=1`;

    return await this.api.customQuery(url, options);
  }

  async onFormChange() {
    const {status, answer} = await this.post();

    if (status === 200) {
      this.setImageElement(answer);
      this.formElement.reset();
    } else {
      showToast(answer);
      this.formElement.reset();
    }
  }

  async onRemoveButtonClick() {
    const {status, answer} = await this.post(true);

    if (status === 200) {
      this.setImageElement(DEFAULT_AVATAR_URL);
    } else {
      showToast(answer);
    }
  }
}

export {Avatar};
